export default __webpack_public_path__ + "static/media/twickCollage1.3cb56427.jpg";